import { FC } from "react";
import { NavLink } from "react-router-dom";
import CONSTANTS from "../../constants/constants.json";
import "./styles/navbar.css";

const { SITE_META } = CONSTANTS;

export const Navbar: FC = () => {
  return (
    <nav className="navbar">
      <span className="navbar-brand">
        {SITE_META.BRAND}
        <span className="terminal-cursor" aria-hidden="true" />
      </span>
      <div className="navbar-links">
        <NavLink to="/" end className="navbar-link">
          {SITE_META.NAV.HOME}
        </NavLink>
        <NavLink to="/projects" className="navbar-link">
          {SITE_META.NAV.PROJECTS}
        </NavLink>
        <NavLink to="/books" className="navbar-link">
          {SITE_META.NAV.BOOKS}
        </NavLink>
        <NavLink to="/content" className="navbar-link">
          {SITE_META.NAV.CONTENT}
        </NavLink>
      </div>
    </nav>
  );
};
